import { cva } from "@msuite/ui/libs/cva";

export const gridClasses = cva(["grid grid-cols-[1fr_1.5fr_1.5fr_2fr]"]);
